import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getBlockedCust } from 'store/actions';

const BlockedCustomer = () => {
    const dispatch = useDispatch();

    useEffect(()=>{
        dispatch(getBlockedCust())
    },[])
  return (
    <div className='page-content'>
        <div>
            <h2>Blocked Customer</h2>
        </div>
    </div>
  )
}

export default BlockedCustomer